import { render, staticRenderFns } from "./OrderSampleAnalysesIndex.vue?vue&type=template&id=7bd73ce2"
import script from "./OrderSampleAnalysesIndex.vue?vue&type=script&lang=js"
export * from "./OrderSampleAnalysesIndex.vue?vue&type=script&lang=js"
import style0 from "./OrderSampleAnalysesIndex.vue?vue&type=style&index=0&id=7bd73ce2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports